async function detectPowerSavingMode() {
  const video = document.createElement('video');

  video.preload = 'auto';
  video.src = '/wp-content/themes/timberwolf-theme/dist/images/pixel.mp4';
  video.muted = true;
  video.playsInline = true;

  try {
    await video.play();

    video.pause();

    return false;
  } catch (e) {
    return true;
  }
}

class DeviceController {
  constructor () {
    this._isMac = null;
    this._isSafari = null;
    this._isFirefox = null;
  }

  init() {
    this._isMac = /(macintosh|macintel|macppc|mac68k|macos)/i.test(navigator.userAgent);
    this._isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this._isFirefox = /firefox/i.test(navigator.userAgent);
  }

  get isMac () {
    return this._isMac;
  }

  get isSafari () {
    return this._isSafari;
  }

  get isFirefox () {
    return this._isFirefox;
  }

  get isLowPower () {
    return detectPowerSavingMode();
  }
}

if (!window.__xtrndDevice) {
  window.__xtrndDevice = new DeviceController();
}

export default window.__xtrndDevice;